<template>
  <div style="display: flex; position: relative">
    <!-- Mobile: Native HTML5 time input with icon -->
    <div v-if="isMobile" style="display: flex; position: relative; width: 100%;">
      <input
        ref="mobileTimeInput"
        type="time"
        class="mobile-time-input w-full h-full"
        :class="readonly ? 'readonly' : ''"
        v-model="time"
        :readonly="readonly"
        :disabled="readonly"
        style="padding: 7px 0.7rem; padding-right: 50px; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); background: white; min-height: 33px;"
        @change="change"
      />
      <div
        class="mobile-icon-wrapper"
        style="position: absolute; top: 0; right: 0; bottom: 0; width: 40px; display: flex; align-items: center; justify-content: center; border-left: 1px solid #cdcdcd; cursor: pointer; background: transparent; z-index: 10;"
        @click="openTimePicker"
        @touchend.prevent="openTimePicker"
      >
        <vs-icon
          icon-pack="feather"
          icon="icon-clock"
          style="font-size: 24px; pointer-events: none;"
        ></vs-icon>
      </div>
    </div>

    <!-- Desktop: flatpickr -->
    <label v-else style="display: flex; position: relative; width: 100%;">
      <flat-pickr
        ref="desktopTimePicker"
        class="flat w-full h-full"
        :class="readonly ? 'readonly' : ''"
        :config="configDateTimePicker"
        v-model="time"
        placeholder=""
        style="padding: 0.7rem; padding-right: 40px; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2)"
        :readonly="readonly"
        :disabled="readonly"
        @change="change"
      />
      <vs-icon
        icon-pack="feather"
        icon="icon-clock"
        style="display: flex; align-items: center; margin-top: 6px; margin-bottom: 6px; padding-left: 6px; padding-right: 6px; position: absolute; top: 0; right: 0; bottom: 0; font-size: 24px; border-left: 1px solid #cdcdcd; cursor: pointer;"
        @click="openTimePicker"
      ></vs-icon>
    </label>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "TimeSelector",
  components: {
    flatPickr,
  },
  props: {
    readonly: Boolean,
    value: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(data) {
      this.time = data;
    },
    time(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      time: this.value,
      windowWidth: window.innerWidth,
      configDateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    change(/*data*/) {},
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    openTimePicker() {
      if (this.readonly) return;

      if (this.isMobile) {
        // 모바일에서는 네이티브 time input을 활성화
        if (this.$refs.mobileTimeInput) {
          // 다양한 방법으로 time picker 활성화 시도
          try {
            // 방법 1: focus + click
            this.$refs.mobileTimeInput.focus();

            // 방법 2: showPicker API 사용 (최신 브라우저)
            this.$nextTick(() => {
              if (typeof this.$refs.mobileTimeInput.showPicker === 'function') {
                this.$refs.mobileTimeInput.showPicker();
              } else {
                // 방법 3: 클릭 이벤트 시뮬레이션
                this.$refs.mobileTimeInput.click();
              }
            });
          } catch (error) {
            console.warn('Time picker activation failed:', error);
            // 마지막 대안: input 요소 자체를 클릭한 것처럼 처리
            this.$refs.mobileTimeInput.click();
          }
        }
      } else {
        // PC에서는 flatpickr picker 열기
        if (this.$refs.desktopTimePicker && this.$refs.desktopTimePicker.fp) {
          this.$refs.desktopTimePicker.fp.open();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flat::v-deep {
  background: white;
}
.flat.readonly::v-deep {
  background: #fafafa;
}

.mobile-time-input {
  background: white;
  outline: none;

  &:focus {
    border-color: #0066cc;
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
  }

  &.readonly {
    background: #fafafa;
    cursor: not-allowed;
  }

  &:disabled {
    background: #fafafa;
    cursor: not-allowed;
    color: #999;
  }
}
</style>

<style>
input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
}

/* 모바일에서 시간 입력 필드의 줌 방지 및 네이티브 아이콘 숨기기 */
@media screen and (max-width: 767px) {
  input[type="time"] {
    font-size: 14px !important;
    font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
  }

  /* 모바일에서 네이티브 time picker indicator 완전히 숨기기 */
  input[type="time"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    right: 0;
    width: 50px;
    height: 100%;
    cursor: pointer;
    z-index: 5;
  }

  /* 모바일에서 커스텀 아이콘 영역 스타일 */
  .mobile-icon-wrapper {
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-icon-wrapper:active {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
